import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtro'
})
export class FiltroPipe implements PipeTransform {

  transform(value: any[], propiedad: string, dato: string, propiedades?: Array<any>): Array<any> {
    let newArr = []
    let ar = []

    if (propiedad == "") {
      for(let j in value){
        value[j].PropiedadGeneral = ""
        for(let i of propiedades){
          value[j].PropiedadGeneral += " " + value[j][i]
        }
  
      }  
      
      propiedad = "PropiedadGeneral"
      for (let i of value) {
        if (String(i[propiedad]).toLocaleLowerCase().indexOf(String(dato).toLocaleLowerCase()) > -1) {
          newArr.push(i)
        }
      }

      // for (let v of value) {
      //   for (let j in v) {
      //     if (String(v[j]).toLocaleLowerCase().indexOf(dato.toLocaleLowerCase()) > -1) {
      //       if(!this.En(v, ar)){
      //         ar.push(v)
      //       }
      //     }
      //   }

      //   if (ar.length>0) {
      //     newArr = newArr.concat(JSON.parse(JSON.stringify(ar)))
      //   }
      // }
    } else {
      for (let i of value) {
        if (String(i[propiedad]).toLocaleLowerCase().indexOf(dato.toLocaleLowerCase()) > -1) {
          newArr.push(i)
        }
      }
    }

    return newArr
  }

  En(row, arr): boolean{
    for(let i of arr){
      if(i==row){
        return true
      }
    }
    return false
  }
}
